import React from "react";
import { Button, Form } from "react-bootstrap";
import ReactPaginate from "react-paginate";

const Pagination = ({ viewpage, handlePageClick, pageCount }) => {
  return (
    <div className="bottom-pagination">
      <div className="paging d-flex justify-content-center align-items-center mb-4">
        <div className="d-flex">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Next"
            forcePage={viewpage}
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="Prev"
            renderOnZeroPageCount={null}
            activeClassName="p-1"
            activeLinkClassName="pagintion-li"
          />
          <div className="d-flex align-items-center">
            <Form.Control className="pagination-search" type="number" />
            <Button className="btn go">GO</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
